import './App.css';
import { Route, Routes } from 'react-router';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout'; 

import Home from './pages/Home';
import ContactPage from './pages/ContactPage';
import Login from './pages/Login';
import About from './pages/About';
import OurServices from './pages/OurServices';
import OurFormations from './pages/OurFormations';
import DemanderDevis from './pages/DemanderDevis';
import DowSession from './pages/DowSession';
import RegisterFormation from './pages/RegisterFormation';
import Certifications from './pages/Certifications';
import ConditionsVente from './pages/ConditionsVente';
import Confidentialite from './pages/Confidentialite';
import NosPartenaires from './pages/NosPartenaires';
import Benin from './pages/Benin';
import Togo from './pages/Togo';
import Centrafrique from './pages/Centrafrique';
import Mali from './pages/Mali';
import Cameroun from './pages/Cameroun';
import CIV from './pages/CIV';
import Congo from './pages/Congo';
import Kinshasa from './pages/Kinshasa';
import Gabon from './pages/Gabon';
import Guinee from './pages/Guinee';
import Niger from './pages/Niger';
import Senegal from './pages/Senegal';
import Tchad from './pages/Tchad';
import ELearningPage from './pages/ElearningPage';
import CertificationsCINEF from './pages/CertificationsCINEF';
import MentionsLegales from './pages/MentionLegales';
import Cookies from './pages/Cookies';
import FormPartners from './pages/FormPartners';
import Dashboard from './pages/Dashboard';
import Newsletter from './pages/Newsletter';
import Devis from './pages/Devis';
import Inscriptions from './pages/Inscriptions';
import ContactAdmin from './pages/ContactAdmin';
import PatnersAdmin from './pages/PatnersAdmin';
import Settings from './pages/Settings';
import AdminManager from './pages/AdminManager';
import AvisAChaud from './pages/AvisChaud';
import Attempt from './pages/Attempt';
import EvalPublic from './pages/EvalPublic';
import Notifications from './pages/Notifications';
import SearchPage from './pages/SearchPage';
import Recueil from './pages/Recueil';
import CreateFormation from './pages/CreateFormation';
import FormationDetail from './pages/FormationDetail';


function App() {
  return (
    <AuthProvider>
      <ThemeProvider> {/* ← entoure tout le contenu */}
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="login" element={<Login />} />
        <Route path="a-propos" element={<About />} />
        <Route path="nos-services" element={<OurServices />} />
        <Route path="nos-formations" element={<OurFormations />} />
        <Route path="ledevis" element={<DemanderDevis />} />
        <Route path="/sessions-en-cours" element={<DowSession />} />
        <Route path="/inscriptionformation" element={<RegisterFormation />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/cgv" element={<ConditionsVente />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/partenaires" element={<NosPartenaires />} />
        <Route path="/partenaires/benin" element={<Benin />} />
        <Route path="/partenaires/togo" element={<Togo />} />
        <Route path="/partenaires/centrafrique" element={<Centrafrique />} />
        <Route path="/partenaires/mali" element={<Mali />} />
        <Route path="/partenaires/cameroun" element={<Cameroun/>} />
        <Route path="/partenaires/cote-ivoire" element={<CIV/>} />
        <Route path="/partenaires/congo" element={<Congo/>} />
        <Route path="/partenaires/rd-congo" element={<Kinshasa/>} />
        <Route path="/partenaires/gabon" element={<Gabon/>} />
        <Route path="/partenaires/guinee" element={<Guinee/>} />
        <Route path="/partenaires/niger" element={<Niger/>} />
        <Route path="/partenaires/senegal" element={<Senegal/>} />
        <Route path="/partenaires/tchad" element={<Tchad/>} />
        <Route path="formations-distance" element={<ELearningPage/>} />
        <Route path="certifications-cinef" element={<CertificationsCINEF/>} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/devenir-partenaire" element={<FormPartners />} />
        <Route path="/formations/:slug" element={<FormationDetail />} />

        {/* Routes Dashboard - Protégées */}
        <Route path="/admin" element={<ProtectedRoute><DashboardLayout><AdminManager /></DashboardLayout></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><DashboardLayout><Dashboard /></DashboardLayout></ProtectedRoute>} />
        <Route path="/newsletter" element={<ProtectedRoute><DashboardLayout><Newsletter /></DashboardLayout></ProtectedRoute>} />
        <Route path="/devis" element={<ProtectedRoute><DashboardLayout><Devis /></DashboardLayout></ProtectedRoute>} />
        <Route path="/inscriptions" element={<ProtectedRoute><DashboardLayout><Inscriptions /></DashboardLayout></ProtectedRoute>} />
        <Route path="/contactdashboard" element={<ProtectedRoute><DashboardLayout><ContactAdmin /></DashboardLayout></ProtectedRoute>} />
        <Route path="/partenariats" element={<ProtectedRoute><DashboardLayout><PatnersAdmin /></DashboardLayout></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><DashboardLayout><Settings /></DashboardLayout></ProtectedRoute>} />
        <Route path="/avis-chaud" element={<ProtectedRoute><DashboardLayout><AvisAChaud /></DashboardLayout></ProtectedRoute>} />
        <Route path="/suggestions" element={<ProtectedRoute><DashboardLayout><Attempt /></DashboardLayout></ProtectedRoute>} />
        <Route path="/formations" element={<ProtectedRoute><DashboardLayout><CreateFormation /></DashboardLayout></ProtectedRoute>} />
        
        {/* Routes publiques */}
        <Route path="/eval/:token" element={<EvalPublic />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/recherche" element={<SearchPage/>} />
        <Route path="/recueil" element={<Recueil />} />
        <Route path="/recueil/:token" element={<Recueil />} />
        <Route path="/formations" element={<CreateFormation />} />
      </Routes>
      </ThemeProvider>
    </AuthProvider> 
  );
}

export default App;